import { render, staticRenderFns } from "./PlanSplit.vue?vue&type=template&id=00238a9f"
import script from "./PlanSplit.vue?vue&type=script&lang=js"
export * from "./PlanSplit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports